export const setList = 'SET/LIST';
export const setEntity = 'SET/ENTITY';
export const deleteEntity = 'DELETE/ENTITY';
export const deleteEntityByCompanyId = 'DELETE/ENTITY_BY_COMPANY_ID';
export const setEntityRevId = 'SET/ENTITY_REV_ID';
export const setProjectFile = 'SET/PROJECT_FILE';
export const setProjectCodeOfConductStatus = 'SET/PROJECT_CODE_OF_CONDUCT_STATUS';
export const revertProjectFileUpdate = 'REVERT/PROJECT_FILE_UPDATE';

const mutations = {
  setList,
  setEntity,
  deleteEntity,
  deleteEntityByCompanyId,
  setEntityRevId,
  setProjectFile,
  setProjectCodeOfConductStatus,
  revertProjectFileUpdate,
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/companyFiles/mutationTypes.js